import {
  FilterView,
  PortfolioFilter,
  FilterViewType,
} from '../../../../state/contexts/portfolioPage';

const isEmptyOrUndefined = (value: string[] | string | undefined) =>
  value === undefined || value === '' || (Array.isArray(value) && value.length === 0);

const ERROR_MESSAGES = {
  DEVICE_FIELDS: 'All device fields must be filled',
  SERIAL_NUMBER: 'Serial number must be filled',
  SERIAL_RANGE: 'Serial number range must be filled',
  SERIAL_RANGE_INVALID: 'Start serial number must be less than end serial number',
  FIRMWARE_FIELDS: 'A firmware version must be filled',
} as const;

const validateDeviceFields = (values: PortfolioFilter) => {
  const hasEquipmentType = !isEmptyOrUndefined(values.equipmentType);
  // Add this when conditional field is added
  // const hasEquipmentQuantityOperator = !isEmptyOrUndefined(values.equipmentQuantityOperator);
  // const hasEquipmentQuantity = !isEmptyOrUndefined(values.equipmentQuantity);

  const shouldAllBeComplete = hasEquipmentType;
  const areAllComplete = hasEquipmentType;

  return shouldAllBeComplete && !areAllComplete ? ERROR_MESSAGES.DEVICE_FIELDS : undefined;
};

const validateFirmwareFields = (values: PortfolioFilter) => {
  // Add this when conditional field is added
  // const hasEquipmentFirmwareVersionOperator = !isEmptyOrUndefined(values.equipmentFirmwareVersionOperator);
  const hasEquipmentFirmwareVersion = !isEmptyOrUndefined(values.equipmentFirmwareVersion);
  const hasEquipmentType = !isEmptyOrUndefined(values.equipmentType);

  const shouldAllBeComplete = hasEquipmentFirmwareVersion || hasEquipmentType;
  const areAllComplete = hasEquipmentFirmwareVersion && hasEquipmentType;

  return shouldAllBeComplete && !areAllComplete ? ERROR_MESSAGES.FIRMWARE_FIELDS : undefined;
};

// TODO: maybe we should use Yup or something similar to validate the filters
export const validateFilters = (values: PortfolioFilter, selectedFilterViews: FilterViewType[]) => {
  const errors: { [key in keyof PortfolioFilter]?: string } = {};

  // Validate device fields
  const equipmentError = validateDeviceFields(values);
  if (equipmentError) errors.equipmentType = equipmentError;

  // Validate serial number
  if (
    selectedFilterViews.includes(FilterView.equipmentSerialNumber) &&
    !values.equipmentSerialNumber
  ) {
    errors.equipmentSerialNumber = ERROR_MESSAGES.SERIAL_NUMBER;
  }

  // Validate firmware fields
  if (selectedFilterViews.includes(FilterView.equipmentFirmwareVersion)) {
    const firmwareError = validateFirmwareFields(values);

    if (firmwareError) errors.equipmentFirmwareVersion = firmwareError;
  }

  return errors;
};
